import { useStoreState } from 'easy-peasy';
import { AppNumbersRow } from '@components/AppNumbers/AppNumbersRow';
import { jobStoreSelector } from '@model/Job/Job.selectors';
import { useMemo } from 'react';

export const AppNumbers = () => {
  const job = useStoreState(jobStoreSelector);

  const {
    atLeastInterviewedProfiles,
    atLeastContactedProfiles,
    notAGoodMatchProfiles,
    profilesWhoAgreedToJobInterview,
    totalCandidatesWithBrandConcerns,
    totalCandidatesWithCompensationConcerns,
    totalCandidatesWithLocationConcerns,
    totalCandidatesWithRoleConcerns,
    interestedProfilesAfterJobInterviewWithoutConcerns,
    presentedProfilesWithConcerns,
    approvedProfilesWithConcerns,
    approvedProfiles,
    presentedProfiles,
  } = job.statistics;

  const jobStatsRows = useMemo(() => {
    const interestedProfilesCountSum =
      approvedProfiles +
      interestedProfilesAfterJobInterviewWithoutConcerns +
      presentedProfiles +
      profilesWhoAgreedToJobInterview;

    const interestedProfilesCount =
      interestedProfilesCountSum -
      approvedProfilesWithConcerns -
      presentedProfilesWithConcerns;

    return [
      {
        profilesCount: atLeastContactedProfiles - notAGoodMatchProfiles,
        profilesWithJobInterviewReportCount: atLeastInterviewedProfiles,
        interestedProfilesCount,
      },
      {
        interestedWithConcerns: [
          {
            value: totalCandidatesWithBrandConcerns,
            reason: 'brand',
          },
          {
            value: totalCandidatesWithCompensationConcerns,
            reason: 'compensation',
          },
          {
            value: totalCandidatesWithLocationConcerns,
            reason: 'location',
          },
          {
            value: totalCandidatesWithRoleConcerns,
            reason: 'role',
          },
        ],
      },
    ];
  }, [job.statistics]);

  return (
    <>
      {jobStatsRows.map((row, rowIdx) => (
        <AppNumbersRow row={row} key={rowIdx} isFirstRow={!rowIdx} />
      ))}
    </>
  );
};
